// extracted by mini-css-extract-plugin
export var bottomRightDock = "_2v-0";